import { PATH } from "routes/paths";
import { getFunnelPaths } from "routes/adFunnel";

/**
 * 카카오 로그인 훅 (프로모션용)
 * - 카카오 OAuth를 통해 idToken을 받아 로그인 처리
 *
 * @param referralCode 제휴(레퍼럴) 진입일 때의 코드. 없으면 일반 프로모션 로그인이다.
 */
export default function useKakaoLoginPromotion(referralCode?: string) {
  const handleKakaoLoginWeb = () => {
    if (!window.Kakao) {
      console.error("[Kakao Login] SDK가 로드되지 않았습니다.");
      return;
    }

    if (!window.Kakao.isInitialized()) {
      console.error("[Kakao Login] SDK가 초기화되지 않았습니다.");
      return;
    }

    // 퍼널은 콜백 경로로 구분한다 — 제휴는 전용 라우트로 돌아온다.
    // 제휴일 때만 state 에 레퍼럴 코드를 실어 보낸다.
    // Kakao 는 성공/취소(error) 모두 state 를 그대로 echo 한다.
    // 프로모션은 광고 채널 prefix(/promotion, /gads)별 콜백으로 돌아온다.
    const callbackPath = referralCode
      ? PATH.kakaoLoginRedirectReferral
      : getFunnelPaths().kakaoCallback;

    window.Kakao.Auth.authorize({
      redirectUri: `${window.location.origin}${callbackPath}`,
      scope: "account_email,openid,phone_number",
      ...(referralCode && { state: referralCode }),
    });
  };

  return handleKakaoLoginWeb;
}
